import { put, call, take, fork } from 'redux-saga/effects'
import { adminPatchService } from '../../api/user'
import { adminPatchSuccess } from '../../reducers/user/action'
import { ADMIN_PATCH } from '../../reducers/user/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* adminPatchFlow(payload) {
  try {
    const { content, callback } = payload

    yield call(adminPatchService, content)
    yield put(adminPatchSuccess(content))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* adminPatchWatcher() {
  while (true) {
    const action = yield take(ADMIN_PATCH)
    const { payload } = action

    yield fork(generalSaga, adminPatchFlow, payload)
  }
}
